/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const IconsSVG = props => {
	const { icon, color = '' } = props

	const renderIcon = {
		dangerIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 13.9 13.9'
				{...props}
			>
				<defs>
					<style>
						{'.prefix__a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}'}
					</style>
				</defs>
				<g transform='translate(.75 .75)'>
					<circle className='prefix__a' cx={6.2} cy={6.2} r={6.2} stroke={color} />
					<path className='prefix__a' d='M6.2 8.652V5.995M6.2 3.875' stroke={color} />
				</g>
			</svg>
		),
		alertIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 19.559 17.213'
				{...props}
			>
				<defs>
					<style>
						{'.prefix__a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
					</style>
				</defs>
				<path
					className='prefix__a'
					d='M8.346 1.82L1.231 13.698a1.68 1.68 0 001.436 2.52h14.23a1.681 1.681 0 001.436-2.52L11.219 1.82a1.68 1.68 0 00-2.873 0zM9.782 6.133v3.323M9.782 12.779h.008'
					stroke={color}
				/>
			</svg>
		),
		mareosIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='3.5 3.5 29 29'
				width='1em'
				height='1em'
				{...props}
			>
				<defs />
				<g id='prefix__Grupo_7460' data-name='Grupo 7460'>
					<path
						id='prefix__Trazado_13530'
						data-name='Trazado 13530'
						d='M17.9 32.16A14.26 14.26 0 1132.16 17.9 14.26 14.26 0 0117.9 32.16zm0-27.51A13.26 13.26 0 1031.16 17.9 13.25 13.25 0 0017.9 4.65z'
						fill={color}
					/>
				</g>
				<path
					className='prefix__cls-2'
					d='M22.35 23.32a1.93 1.93 0 01-1.08 1.6 2.06 2.06 0 01-2.21-.12l-.26-.18a2.23 2.23 0 00-2.46-.24q-.6.29-1.17.6A2.11 2.11 0 0112 23.59a3.23 3.23 0 01.46-2.36 4.1 4.1 0 012.69-1.81 7.66 7.66 0 015.06.41 3.76 3.76 0 012.14 3.49zm-5.19-3.19a7.67 7.67 0 00-2.53.52 2.63 2.63 0 00-1.71 2.53 1.19 1.19 0 001.84 1.09c.37-.2.72-.41 1.1-.58a3.28 3.28 0 012.24-.34 4.21 4.21 0 011.38.67 1.23 1.23 0 001.42.09 1.18 1.18 0 00.58-1.24 2.56 2.56 0 00-1.54-2.15 6.69 6.69 0 00-2.78-.59zM15.74 15.62a2.92 2.92 0 01-2.05 2.86 3.37 3.37 0 01-4.5-2.88 4 4 0 011.71-4l.24-.15a.45.45 0 01.48.76 3.34 3.34 0 00-1 1 3.17 3.17 0 00.49 4 2.41 2.41 0 003.34-.21 2 2 0 00.14-2.16 1.39 1.39 0 00-1.89-.5 1.07 1.07 0 00-.35 1.58.72.72 0 00.93.18c.26-.15.32-.39.18-.77a.45.45 0 11.81-.37 1.4 1.4 0 01-1.09 2 1.58 1.58 0 01-1.57-.6 1.81 1.81 0 01-.24-1.91 2.23 2.23 0 013.43-.75 2.51 2.51 0 01.94 1.92zM22.17 11.27a3.6 3.6 0 013.44 3 4.16 4.16 0 01-1.84 4.21.44.44 0 01-.53 0 .75.75 0 01-.24-.41c-.05-.19.11-.31.26-.41a3.21 3.21 0 001.22-4 2.5 2.5 0 00-3.33-1.38 1.94 1.94 0 00-.91 2.78 1.39 1.39 0 001.86.48 1.07 1.07 0 00.45-1.45.71.71 0 00-.87-.37.54.54 0 00-.35.77c.13.31.07.53-.18.65a.43.43 0 01-.59-.19 1.39 1.39 0 011-2.05 1.61 1.61 0 011.93 1.1 1.9 1.9 0 01-.74 2.27 2.38 2.38 0 01-3.67-2 2.78 2.78 0 012.2-2.92 8.68 8.68 0 01.89-.08z'
				/>
			</svg>
		),
		orinaderaIcon: (
			<svg
				id='prefix__Layer_1'
				xmlns='http://www.w3.org/2000/svg'
				x={0}
				y={0}
				viewBox='0 0 30 30'
				xmlSpace='preserve'
				width='1em'
				height='1em'
				{...props}
			>
				<circle id='prefix__Ellipse_502' cx={935.1} cy={535.6} r={17.9} fill={color} />
				<path
					className='prefix__st1'
					d='M935.1 521.4c-7.9 0-14.3 6.4-14.3 14.3s6.4 14.3 14.3 14.3 14.3-6.4 14.3-14.3c-.1-8-6.5-14.3-14.3-14.3zm0 27.5c-7.3 0-13.3-5.9-13.3-13.3 0-7.3 5.9-13.3 13.3-13.3 7.3 0 13.3 5.9 13.3 13.3-.1 7.3-6 13.3-13.3 13.3z'
					fill={color}
				/>
				<path
					className='prefix__st1'
					d='M939.5 541c.1-.6.3-1.1.7-1.6.1-.2.2-.4.1-.6-.1-.2-.3-.4-.5-.5-.3 0-.5.1-.7.3-.4.5-.7 1.2-.9 1.8-1.8-1.2-4-1.2-5.8-.1 0-.1-.1-.3-.1-.4-.2-.4-.4-.9-.7-1.3 0 0 0-.1-.1-.1-.2-.3-.6-.3-.9-.1-.3.2-.3.6-.1.9.2.2.3.4.4.7.4.7.4 1.5.1 2.2-.1.3-.3.5-.5.7-.1.2-.1.3-.1.5 0 .3.2.5.5.5.3.1.5 0 .7-.2.5-.5.8-1.2 1-1.9 0-.1 0-.1.1-.2.9-.7 2.1-1 3.2-.9.8.1 1.5.5 2.1.9.2.1.3.3.4.6.1.6.4 1.1.9 1.5.1.1.2.2.3.2.4.1.7-.1.8-.5.1-.3 0-.6-.2-.7-.6-.3-.8-1-.7-1.7zM933.9 533c0-2.1-1.7-3.8-3.8-3.8-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8zm-1.4 0c0 1.2-.9 2.2-2 2.4h-.3c-.5 0-1-.1-1.3-.4-.1-.1-.2-.2-.3-.2h-.1c-.4-.4-.7-1-.7-1.7 0-1.3 1.1-2.4 2.4-2.4.3 0 .6.1.8.2.8.2 1.5 1.1 1.5 2.1zM940.4 529.3c-2.1 0-3.8 1.7-3.8 3.7 0 2.1 1.7 3.8 3.7 3.8 2.1 0 3.8-1.7 3.8-3.7.1-2.1-1.6-3.8-3.7-3.8zm0 6.1c-1.3 0-2.4-1.1-2.4-2.4v-.4c.2-1.1 1.2-2 2.4-2 1.3 0 2.4 1.1 2.4 2.4 0 1.4-1.1 2.4-2.4 2.4z'
					fill={color}
				/>
				<path
					className='prefix__st1'
					d='M929.9 531.3c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.8 0 1.5-.7 1.5-1.6.1-.9-.6-1.6-1.5-1.6zM940.1 531.3c-.9 0-1.5.7-1.5 1.6 0 .9.7 1.5 1.6 1.5s1.5-.7 1.5-1.6c0-.8-.7-1.5-1.6-1.5z'
					fill={color}
				/>
				<g>
					<path d='M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0zm0 28.9C7.3 29 1.1 22.7 1.1 15 1 7.3 7.3 1.1 15 1.1S28.9 7.3 28.9 15 22.7 28.9 15 28.9z' />
					<path d='M19.7 20.7c.1-.6.4-1.2.7-1.6.1-.2.2-.4.1-.6-.1-.3-.3-.5-.6-.5-.3-.1-.6.1-.7.3-.4.6-.8 1.2-.9 1.9-1.9-1.2-4.2-1.3-6.1-.1 0-.1-.1-.3-.1-.4-.2-.5-.5-.9-.8-1.4 0 0 0-.1-.1-.1-.2-.3-.7-.3-.9-.1-.3.2-.4.7-.1 1 .2.2.3.5.4.7.4.7.4 1.6.1 2.4-.1.3-.4.5-.5.8-.1 0-.2.2-.2.4 0 .3.2.5.5.6.3.1.6 0 .7-.2.5-.5.9-1.2 1-2 0-.1 0-.2.1-.2 1-.7 2.2-1.1 3.4-.9.8.1 1.6.5 2.2 1 .2.1.4.3.4.6.2.6.5 1.1.9 1.6.1.1.2.2.3.2.4.1.8-.1.9-.5.1-.3 0-.6-.2-.8-.5-.6-.7-1.4-.5-2.1zM13.8 12.3c0-2.2-1.8-4-4-4s-4 1.8-4 4 1.8 4 4 4 4-1.8 4-4zm-1.5 0c0 1.3-.9 2.3-2.2 2.5h-.4c-.5 0-1-.2-1.4-.4l-.3-.3h-.1c-.5-.5-.7-1.1-.7-1.8 0-1.4 1.1-2.5 2.5-2.5.3 0 .6.1.9.2 1 .3 1.7 1.2 1.7 2.3zM20.6 8.3c-2.2 0-4 1.8-4 3.9 0 2.2 1.7 4 3.9 4s4-1.8 4-3.9c.1-2.2-1.7-4-3.9-4zm0 6.5c-1.4 0-2.5-1.1-2.5-2.5v-.4c.2-1.2 1.2-2.1 2.5-2.1 1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z' />
					<path d='M9.6 10.5c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM20.4 10.5c-.9 0-1.6.8-1.6 1.7 0 .9.8 1.6 1.7 1.6.9 0 1.6-.8 1.6-1.7-.1-.9-.8-1.7-1.7-1.6z' />
				</g>
			</svg>
		),
		felizIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='1 1 21 21'
				x={0}
				y={0}
				width='1em'
				height='1em'
				{...props}
			>
				<defs />
				<g id='prefix__Capa_2' data-name='Capa 2'>
					<g id='prefix__Capa_1-2' data-name='Capa 1'>
						<path
							d='M11.74 2.27a9.45 9.45 0 109.45 9.45 9.46 9.46 0 00-9.45-9.45zM20 11.73a8.31 8.31 0 11-8.3-8.3 8.31 8.31 0 018.3 8.3z'
							fill={color}
						/>
						<path
							d='M7.84 11a.49.49 0 00.34-.47.9.9 0 01.15-.46.44.44 0 01.54 0 .73.73 0 01.17.47.51.51 0 00.5.51.5.5 0 00.5-.49 1.76 1.76 0 00-.45-1.18 1.46 1.46 0 00-2 0 1.78 1.78 0 00-.43 1.17.49.49 0 00.49.49h.14zM13.87 9.38a1.74 1.74 0 00-.44 1.17.5.5 0 00.5.49h.13a.5.5 0 00.35-.47.81.81 0 01.14-.46.45.45 0 01.55 0 .78.78 0 01.16.47.51.51 0 00.5.51.5.5 0 00.5-.49 1.8 1.8 0 00-.44-1.18 1.46 1.46 0 00-1.95-.04zM15.42 12.92a.39.39 0 00-.18 0h-7a.47.47 0 00-.43.63 4.16 4.16 0 003.87 2.67h.09a4.22 4.22 0 003.92-2.68.43.43 0 000-.35.44.44 0 00-.27-.27z'
							fill={color}
						/>
					</g>
				</g>
			</svg>
		),
		alteracionDeLaConcienciaIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 30 30'
				width='1em'
				height='1em'
				{...props}
			>
				<path d='M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0zm0 28.9C7.3 29 1.1 22.7 1.1 15 1 7.3 7.3 1.1 15 1.1S28.9 7.3 28.9 15 22.7 28.9 15 28.9z' />
				<path d='M15.5 16.1c-.1 0-.1 0 0 0-2.1 0-3.7 1.7-3.7 3.7 0 2.1 1.7 3.7 3.7 3.7 2.1 0 3.7-1.7 3.7-3.7s-1.7-3.7-3.7-3.7zm-.1 6.1c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4 1.3 0 2.4 1.1 2.4 2.4 0 1.3-1 2.4-2.4 2.4zM22.8 12.5c-.2.1-.3.2-.4.3-.7.7-1.7.9-2.6.6-.9-.3-1.4-1.2-1.2-2.1v.4c.2 1 1.1 1.6 2.1 1.4 1.1-.2 1.8-1.3 1.6-2.4 0-.1-.1-.3-.1-.4-.5-1.3-2-1.9-3.2-1.4h-.1c-1.5.7-2.2 2.4-1.5 3.9.8 1.6 2.6 2.4 4.3 1.8.6-.2 1.2-.6 1.7-1.1.2-.2.3-.5.1-.8-.1-.2-.4-.3-.7-.2zm-3.3-2.4c.3 0 .5 0 .8.1.1 0 .2 0 .3.1.4.2.6.8.4 1.2-.1.3-.4.4-.7.3-.1 0-.2 0-.2-.1-.2-.1-.2-.4 0-.5 0 0 .1-.1.1-.2.1-.3 0-.7-.4-.8-.2 0-.2 0-.3-.1zM13.3 10.8c-.1-.3-.2-.6-.3-.8-.8-1.2-2.4-1.6-3.6-.8-.3.1-.4.2-.6.4-.8.9-.7 2.3.2 3.1.1.1.1.1.2.1.8.6 2 .3 2.5-.5.1-.3.3-.6.3-.9.1.4 0 .9-.3 1.2-.7 1-2.2 1.2-3.2.5-.2-.1-.3-.3-.5-.5s-.5-.2-.7-.1c-.2.1-.3.4-.3.7 0 .2.1.3.2.5 1.1 1.2 2.8 1.6 4.3.9 1.4-.7 2.2-2.3 1.8-3.8zm-2.3-.7c-.1.1-.3.2-.4.3-.2.2-.2.5-.1.7.2.3.2.5 0 .6-.3.2-.6.1-.8-.1-.3-.4-.2-.9.2-1.2.3-.3.7-.4 1.1-.3z' />
			</svg>
		),
		temblorIcon: (
			<svg
				id='prefix__Layer_1'
				xmlns='http://www.w3.org/2000/svg'
				x={0}
				y={0}
				viewBox='0 0 30 30'
				xmlSpace='preserve'
				width='1em'
				height='1em'
				{...props}
			>
				<style>{`.prefix__st0{fill: ${color}}`}</style>
				<path
					className='prefix__st0'
					d='M21.6 1.5C14.2-2.1 5.2 1 1.5 8.4c-3.6 7.4-.5 16.4 6.9 20.1 7.4 3.6 16.4.6 20.1-6.9 3.6-7.4.5-16.4-6.9-20.1zm5.9 19.6c-3.4 6.9-11.7 9.8-18.7 6.4C2 24.1-.9 15.8 2.5 8.9 5.9 2 14.2-.9 21.1 2.5c7 3.4 9.8 11.7 6.4 18.6z'
				/>
				<path
					className='prefix__st0'
					d='M9.8 13.9c2 1 4.3.1 5.3-1.8 1-2 .1-4.3-1.8-5.3-2-1-4.3-.1-5.3 1.8-1 1.9-.2 4.3 1.8 5.3zm-.5-4.7C9.9 8 11.4 7.4 12.7 8s1.8 2.1 1.2 3.4c-.6 1.2-2.1 1.8-3.4 1.2-1.3-.7-1.8-2.2-1.2-3.4zM23 11.5c-2-1-4.3-.2-5.3 1.8s-.2 4.3 1.8 5.3 4.3.2 5.3-1.8c.9-2 .1-4.3-1.8-5.3zm.5 4.6c-.6 1.3-2.1 1.8-3.4 1.2H20c-1.2-.6-1.7-2.2-1.1-3.4.6-1.2 2.2-1.7 3.4-1.1 1.2.6 1.7 2.1 1.2 3.3z'
				/>
				<path
					className='prefix__st0'
					d='M10.7 11.5c.8.4 1.8 0 2.2-.8.4-.8.1-1.8-.8-2.2-.8-.4-1.8-.1-2.2.8s0 1.8.8 2.2zM21.8 13.3c-.8-.4-1.8 0-2.2.8-.4.8 0 1.8.8 2.2.8.4 1.8 0 2.2-.8.4-.9 0-1.8-.8-2.2zM16.3 21.3c-.3.2-.7.4-1 .5-.8.4-1.8.1-2.3-.7-.2-.4-.4-.7-.6-1.1-.4-.9-1.1-1.7-2.1-2.1-1.1-.4-2.3-.3-3.5.1-.3.1-.4.4-.3.7.1.3.4.4.7.3h.2c.6-.2 1.3-.3 2-.1.8.1 1.4.7 1.8 1.4.3.5.5 1.1.8 1.5.4.7 1.2 1.2 2 1.3 1 .1 2.1-.2 2.9-.8.2-.2.3-.5.1-.7-.1-.4-.4-.4-.7-.3z'
				/>
			</svg>
		),
		medicineBottleIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 20.646 27.195'
				{...props}
			>
				<path
					d='M14.689 8.14l-.025-1.285A3.266 3.266 0 0013.6.5H7.049a3.267 3.267 0 00-1.092 6.348V8.14A5.464 5.464 0 00.5 13.6v7.64a5.464 5.464 0 005.457 5.457h8.732a5.464 5.464 0 005.457-5.457V13.6a5.464 5.464 0 00-5.457-5.46zm-7.64-5.457H13.6a1.091 1.091 0 010 2.183H7.049a1.091 1.091 0 110-2.183zm10.914 18.555a3.274 3.274 0 01-3.274 3.274H5.957a3.274 3.274 0 01-3.274-3.274V13.6a3.274 3.274 0 013.274-3.277h1.092A1.091 1.091 0 008.14 9.232V7.049h4.336l.029 2.2a1.091 1.091 0 001.095 1.074h1.091a3.274 3.274 0 013.272 3.277zm-3.274-4.366a1.091 1.091 0 01-1.089 1.091h-2.185v2.183a1.091 1.091 0 11-2.183 0v-2.183H7.049a1.091 1.091 0 110-2.183h2.183V13.6a1.091 1.091 0 112.183 0v2.18H13.6a1.091 1.091 0 011.089 1.092z'
					fill={color}
					stroke='transparent'
				/>
			</svg>
		),
		menuHamburger: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 32.3 27.845'
				{...props}
			>
				<defs>
					<clipPath id='prefix__a'>
						<path fill='none' d='M0 0h32.3v27.845H0z' />
					</clipPath>
					<style>{'.prefix__c{fill:none;stroke-linecap:round;stroke-width:1.7px}'}</style>
				</defs>
				<g clipPath='url#prefix__a'>
					<path className='prefix__c' d='M.65.65h31M.65 11.65h31M.65 22.65h31' stroke={color} />
				</g>
			</svg>
		),
		close: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 21.349 21.45'
				{...props}
			>
				<path
					d='M12.307 10.724l8.747-8.96a1.043 1.043 0 00-.015-1.467 1.028 1.028 0 00-1.46.014l-8.731 8.946L1.755.297a1.028 1.028 0 00-1.46.014 1.043 1.043 0 00.014 1.467l9.079 8.946-9.08 8.946a1.043 1.043 0 00-.014 1.467 1.026 1.026 0 001.46.014l9.093-8.96 8.731 8.946a1.026 1.026 0 00.738.313 1.014 1.014 0 00.723-.3 1.042 1.042 0 00.015-1.467z'
					fill={color}
					fillRule='evenodd'
				/>
			</svg>
		),
		arrowRightIcon: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 14.044 14.176'
				{...props}
			>
				<g stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5}>
					<path fill='none' d='M.75 6.95h12' />
					<path d='M7.267 1.061l6.027 6.027-6.027 6.027' fill='transparent' />
				</g>
			</svg>
		),
		asesoriaPsicologica: (
			<svg
				id='prefix__Layer_1'
				xmlns='http://www.w3.org/2000/svg'
				x={0}
				y={0}
				viewBox='0 0 25 21'
				xmlSpace='preserve'
				width='1em'
				height='1em'
				{...props}
			>
				<style>
					{`
            .prefix__st0{fill: ${color}}
          `}
				</style>
				<path
					className='prefix__st0'
					d='M24.3 17.2c-.3-.1-.6 0-.7.2-.9 1.7-2.7 2.8-4.7 2.7-2.8 0-5.1-2-5.1-4.5s2.3-4.5 5.1-4.5c2-.1 3.8 1 4.7 2.8.1.2.4.3.6.2.2-.1.3-.3.3-.5-1.1-2.1-3.3-3.4-5.6-3.3-.5 0-1.1.1-1.6.2V6.9c0-3.8-3.5-6.9-7.8-6.9S1.6 3.1 1.6 6.9v3.7C.7 11 .2 11.8.1 12.8c.1 1.3 1.1 2.3 2.4 2.4-.5.4-.8 1.1-.8 1.8v3.6c0 .2.3.4.5.4h14.5c.2 0 .3-.1.4-.2.6.2 1.2.2 1.8.2 2.3.1 4.5-1.2 5.6-3.3.1-.2 0-.4-.2-.5zM1.1 12.8c0-.7.5-1.3 1.2-1.5.2-.1.3-.2.3-.4v-4c0-3.3 3.1-6 6.9-6s6.9 2.7 6.9 6v3.9c-1.6.6-2.8 1.9-3.3 3.6h-2v-1.1c.9-.2 1.8-.8 2.4-1.5.7-.8 1.1-1.8 1.1-2.8V7.5c0-.2-.2-.4-.4-.4-1.1-.3-2.1-.9-3-1.7-.2-.2-.5-.4-.7-.6-.7-.8-1.8-1.2-2.9-1.1-1 0-2 .6-2.6 1.5-.4.6-.6 1.4-.6 2.1V9c0 1 .4 2 1.1 2.8.7.7 1.5 1.2 2.4 1.5v1.1H3c-1 0-1.8-.7-1.9-1.6zm7.4-.2c-1.7-.3-3.1-1.8-3.2-3.6V7.3c0-.6.2-1.2.5-1.7.5-.6 1.2-1 1.9-1.1.8-.1 1.5.2 2.1.8l.7.7c.9.8 1.9 1.4 3.1 1.8V9c-.1 1.8-1.4 3.3-3.2 3.5-.2 0-.4.2-.4.4v1.4H8.9V13c0-.2-.2-.4-.4-.4zm-5.8 7.5V17c.1-1 1-1.8 2-1.7h1.9l2.2 4.9H2.7zm4.9-4.9H11l-1.6 4.1-1.8-4.1zm2.5 4.9l1.9-4.9h.8v.4c0 1.9 1.1 3.6 2.8 4.5h-5.5z'
				/>
				<path
					className='prefix__st0'
					d='M24.5 15.4c-.2 0-.3.2-.3.4s.2.3.4.3h.1c.1-.1.2-.2.2-.4-.1-.2-.3-.3-.4-.3zM22.6 16.4v-.2c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3-.4 0-.6.3-.6.6v.2c0 .5-.3 1-.8 1.1v-1.4c.2-.1.3-.2.2-.4 0-.1-.2-.2-.3-.2h-.5c-.2 0-.3.1-.3.3 0 .1.1.3.2.3v1.4c-.5-.1-.8-.6-.8-1.1v-.2c0-.4-.3-.6-.6-.6-.2 0-.3.1-.3.3 0 .2.1.3.3.3v.2c0 .9.6 1.6 1.5 1.8v.8c-.2.1-.3.2-.2.4 0 .1.2.2.3.2h.5c.2 0 .3-.1.3-.3 0-.1-.1-.3-.2-.3v-.8c.7-.2 1.3-.9 1.3-1.8z'
				/>
			</svg>
		),
		consultaFamiliar: (
			<svg
				id='prefix__Layer_1'
				xmlns='http://www.w3.org/2000/svg'
				x={0}
				y={0}
				viewBox='0 0 25 20'
				xmlSpace='preserve'
				width='1em'
				height='1em'
				{...props}
			>
				<style>
					{` 
            .prefix__st0{fill: ${color}}
          `}
				</style>
				<g id='prefix__familia_1_'>
					<g id='prefix__Group_12799'>
						<path
							id='prefix__Path_38376'
							className='prefix__st0'
							d='M5.5 7.1c-.2 0-.5.3-.5.5s.1.3.2.4c.7.7 1.8.7 2.5 0 .2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0-.3.3-.7.3-1 0-.2-.1-.3-.2-.5-.2z'
						/>
						<path
							id='prefix__Path_38377'
							className='prefix__st0'
							d='M25 9.8c.1-.2-.1-.5-.3-.6-1.5-.3-2.5-1.7-2.5-3.2V5c.1-1.3-.3-2.6-1.1-3.7C20.4.5 19.3 0 18.2 0c-1.1 0-2.1.4-2.8 1.3-.8 1.1-1.2 2.4-1.1 3.7v1c0 1-.4 2-1.3 2.5-1.5-.3-3 .5-3.5 2-.1 0-.8-.2-1-.3v-.3c1.4-.7 2.2-2.1 2.2-3.7V4.3C10.7 2 8.8.1 6.5.1S2.2 2 2.2 4.3v1.9c0 1.5.8 2.9 2.2 3.7v.3c-.2.1-.4.1-.6.2-1.7.5-3.8 1-3.8 3.6v4.3c0 .3.2.5.5.5h6.6v.7c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2v-.3c0-.3 0-.6.1-.9.3-.9 1.1-1.1 2.2-1.4h.2c.3.7 1 1.2 1.7 1.2.8 0 1.5-.5 1.8-1.2h.1c1.4.4 2.3.7 2.3 2.3v.3h-2c-.3 0-.5.2-.5.5s.2.5.5.5H17c.3 0 .5-.2.5-.5v-.7H24c.3 0 .5-.2.5-.5V14c0-.8-.3-1.6-.9-2.2.8-.4 1.3-1.2 1.4-2zm-6.8-8.7c.8-.1 1.6.3 2.1.9.6.8.9 1.7.8 2.7-1 .3-2.1-.2-2.6-1.1-.1-.2-.4-.3-.7-.2-.1 0-.2.1-.2.2-.5.9-1.5 1.4-2.6 1.1.3-2.3 1.4-3.6 3.2-3.6zm-3 4.5h.6c.9 0 1.8-.4 2.4-1.1.6.7 1.5 1.1 2.4 1.1h.6V6c0 1.7-1.3 3-3 3s-3-1.3-3-3v-.4zm4 4.3v.7c0 .6-.5 1-1 1s-1-.4-1-1v-.7c.6.2 1.3.2 2 0zM14.7 8c.4.6.9 1.1 1.5 1.5v.8c-.2.1-.4.1-.6.2l-.3.1c-.3-.7-.8-1.3-1.4-1.6.3-.3.6-.6.8-1zm-4.4 2.8c.4-1.1 1.7-1.6 2.8-1.2.7.3 1.2.9 1.3 1.6-1.3-.6-2.9-.6-4.2 0 0-.1.1-.2.1-.4zM3.2 4.3c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v.5c-1.4.1-2.9-.2-4.1-.9-.2-.1-.5-.1-.7.1-.4.5-1 .8-1.7.8v-.5h.1zm0 2v-.5c.8 0 1.5-.3 2.1-.8 1.3.7 2.8 1 4.3.9v.5c0 1.8-1.4 3.2-3.2 3.2S3.2 8 3.2 6.3zm4.2 4v.3c0 .6-.5 1-1 1s-1-.4-1-1v-.3c.6.2 1.3.2 2 0zm3 5l-.3.1c-1.2.4-2.5.8-2.9 2.4H3.6v-2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2H1V14c0-1.7 1.2-2.1 3-2.6.2 0 .3-.1.5-.1.3 1 1.5 1.6 2.5 1.3.6-.2 1.1-.7 1.3-1.3.2 0 .8.2.9.3V12.4c0 1 .5 1.9 1.2 2.5v.4zm2.8.3c0 .5-.4.9-.9.9s-.8-.4-.9-.9v-.3c.1 0 .2.1.4.1.3.1.7.1 1 0 .2 0 .3-.1.5-.1v.3zm.3-1.5c-1 .6-2.3.3-3-.7-.2-.3-.3-.7-.3-1.1 1.3-.9 3-.9 4.3 0-.1.8-.4 1.5-1 1.8zm10 3.7h-1.6v-2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2h-3.5c-.4-1.6-1.7-2-2.9-2.4l-.3-.1v-.5c.8-.6 1.3-1.5 1.3-2.5v-.7-.2l.4-.1c.2 0 .3-.1.5-.1.3 1 1.5 1.6 2.5 1.3.6-.2 1.1-.7 1.3-1.3.2 0 .3.1.5.1 1.9.5 3 .9 3 2.6l-.2 3.9zm-.9-6.8c-.6-.3-1.2-.5-1.8-.6-.2-.1-.4-.1-.6-.2v-.7c.6-.4 1.1-.9 1.5-1.5.5.9 1.3 1.6 2.3 2-.2.6-.8 1-1.4 1z'
						/>
						<path
							id='prefix__Path_38379'
							className='prefix__st0'
							d='M12.3 18.9c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z'
						/>
					</g>
				</g>
			</svg>
		),
		dueloAnciedad: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 15 20'
				width='1em'
				height='1em'
				{...props}
			>
				<path
					d='M14.999 19.2l-.5-3.7c-.3-2.5-2.3-3-3.9-3.4l-.3-.1c-.2-.1-.4-.4-.5-.6 1-.7 1.8-1.7 2.2-2.9.3-.1.6-.2.8-.4.3-.3.5-.6.5-1v-.5c0-.5-.4-.8-.8-.8h-.3c0-.6-.2-1.3-.4-1.9.3-.3.5-.8.5-1.2-.1-.8-.5-1.7-1-2.3-.1-.2-.3-.3-.6-.3-.2 0-.5.1-.6.3-.2.3-.4.7-.6 1-.6-.3-1.3-.5-2-.5s-1.4.2-2.1.5c-.2.1-.2.3-.1.5 0 .1.1.2.2.2h.3c1.1-.6 2.3-.6 3.4 0-.1.2-.1.4-.1.6 0 .4.2.9.5 1.2.3.3.7.4 1.1.4h.4c.2.5.3.9.3 1.4-.3-.1-.6-.3-.9-.6-.3-.5-1-.7-1.5-.5h-.2c-.1 0-.3.1-.4.1-.6.3-1.3.3-1.9 0h-.1c-.1 0-.3 0-.4-.1-.6-.2-1.2.1-1.5.5-.3.3-.6.5-.9.6 0-1.1.5-2.1 1.2-2.9.2-.2.1-.4 0-.5-.1-.2-.4-.2-.5-.1-.9 1-1.4 2.2-1.5 3.5h-.3c-.4.1-.8.4-.8.9V7c0 .4.2.8.5 1 .2.2.5.4.8.4.4 1.2 1.1 2.3 2.1 3-.1.2-.2.5-.5.6l-.3.1c-.7.2-1.3.4-1.9.7-.2.1-.3.3-.2.5.1.2.3.3.5.2.6-.3 1.2-.5 1.8-.6l.3-.1 1.8 1.1c.5.4 1.2.4 1.7 0l1.8-1.1.3.1c1.5.4 3 .8 3.3 2.8l.5 3.7h-2.5v-1.7c0-.2-.2-.4-.4-.4s-.4.2-.4.4v1.7h-6.8v-1.7c0-.4-.2-.6-.4-.6s-.4.2-.4.4v1.7h-2.5l.5-3.7c.1-.5.2-1 .6-1.4.1-.2.1-.4-.1-.5-.1-.1-.2-.1-.3-.1-.1 0-.2.1-.3.1-.4.5-.7 1.1-.7 1.8l-.5 3.7c0 .2 0 .4.1.6.2.1.4.2.6.2h13.6c.3 0 .6-.2.6-.5.1 0 .1-.1.1-.2zm-2.8-11.7v-1h.3s.1 0 .1.1V7c-.1.2-.2.4-.4.5zm-5.6 3.8c-1.5-.6-2.5-1.8-3-3.2 0-.2-.1-.4-.1-.6v-1c.6-.1 1.2-.4 1.5-.8.3-.3.4-.4.8-.3h.2c.2 0 .3.1.4.1.8.3 1.6.3 2.3 0 .2 0 .3-.1.6-.1.4-.1.5 0 .7.3.4.4.9.7 1.5.8v1c0 .2 0 .4-.1.6-.4 1.5-1.5 2.6-2.9 3.2-.7.2-1.3.2-1.9 0zm-.8.5c.2.1.3.1.5.2.8.3 1.7.3 2.4 0 .2-.1.3-.1.5-.2.1.2.1.3.3.4l-1.6.9c-.2.2-.6.2-.9 0l-1.5-.9c.2-.1.2-.3.3-.4zm5.8-9.1c0 .3-.1.6-.4.7-.1.1-.3.1-.4.1-.2 0-.4-.1-.6-.2-.2-.1-.3-.3-.3-.5v-.1c0-.2.1-.4.2-.6.2-.4.4-.8.7-1.2.3.5.6 1.1.8 1.8zm-8.8 4.8s-.1 0 0 0l-.1-.1c-.1-.1-.2-.2-.2-.4v-.4-.1h.3v1z'
					fill={color}
				/>
			</svg>
		),
		clock: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 13.5 13.5'
				{...props}
			>
				<defs>
					<style>
						{`.prefix__a{fill:none;stroke: ${color} ;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}`}
					</style>
				</defs>
				<g transform='translate(.75 .75)'>
					<circle className='prefix__a' cx={6} cy={6} r={6} />
					<path className='prefix__a' d='M5.813 2.397v3.136l2.09 1.045' />
				</g>
			</svg>
		),
		likeHand: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 24.7 25.1'
				width='1em'
				height='1em'
				{...props}
			>
				<path
					d='M20 25.1H3.1C1.4 25.1 0 23.7 0 22v-8.3c0-1.7 1.4-3.1 3.1-3.1h3.1L10.7.4c.1-.2.4-.4.7-.4 2.4 0 4.3 1.9 4.3 4.3v4h6.4c1.7.3 2.9 1.8 2.6 3.5l-1.6 10.6c-.3 1.6-1.6 2.7-3.1 2.7zM7.4 23.6H20c.8 0 1.5-.6 1.6-1.4l1.6-10.6c.1-.9-.5-1.7-1.4-1.8h-7c-.2 0-.4-.1-.5-.2s-.1-.4-.1-.6V4.3c0-1.4-1-2.5-2.3-2.8l-4.4 10v12.1zM3.1 12.1c-.9 0-1.6.7-1.6 1.6V22c0 .9.7 1.6 1.6 1.6h2.8V12.1H3.1z'
					fill={color}
				/>
			</svg>
		),
		disLikeHand: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 24.7 25.1'
				width='1em'
				height='1em'
				{...props}
			>
				<path
					d='M4.7 0c.1 0 .1 0 0 0h16.9c1.7 0 3.1 1.4 3.1 3.1v8.3c0 1.7-1.4 3.1-3.1 3.1h-3.1L14 24.7c-.1.3-.4.4-.7.4-2.4 0-4.3-1.9-4.3-4.3v-4H2.6C.9 16.6-.2 15 0 13.3L1.7 2.6C1.9 1.1 3.2 0 4.7 0zm12.6 1.5H4.8c-.8 0-1.5.6-1.7 1.4L1.5 13.5c-.1.9.5 1.7 1.4 1.8h7c.2 0 .4.1.5.2s.2.3.2.5v4.7c0 1.4 1 2.5 2.3 2.8l4.4-10v-12zM21.6 13c.9 0 1.6-.7 1.6-1.6V3.1c0-.9-.7-1.6-1.6-1.6h-2.8V13h2.8z'
					fill={color}
				/>
			</svg>
		),
		fire: (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='1em'
				height='1em'
				viewBox='0 0 18 22.12'
				{...props}
			>
				<path
					d='M5.468 7.395zm9.954-.187a1.237 1.237 0 00-.23-.175 1 1 0 00-1.4.411 5.782 5.782 0 01-1.4 1.777A8.717 8.717 0 008.127.13a1 1 0 00-1.491.806 7.017 7.017 0 01-2.471 4.942l-.23.188a8.513 8.513 0 00-1.988 1.862A8.983 8.983 0 005.6 21.836a1 1 0 001.38-.926 1.05 1.05 0 00-.05-.312 6.977 6.977 0 01-.19-2.581 9 9 0 004.313 4.017 1 1 0 00.715.038 8.995 8.995 0 003.654-14.864zm-3.9 12.831a6.964 6.964 0 01-3.577-4.4 8.908 8.908 0 01-.18-.964 1 1 0 00-.8-.845.982.982 0 00-.191-.019 1 1 0 00-.867.5A8.959 8.959 0 004.7 19.028 6.985 6.985 0 013.522 9.16 6.555 6.555 0 015.084 7.7a.745.745 0 00.074-.055l.307-.251a8.968 8.968 0 002.9-4.633 6.736 6.736 0 011.386 8.088 1 1 0 001.184 1.418A7.856 7.856 0 0014.8 9.582a7 7 0 01-3.279 10.457z'
					fill={color}
				/>
			</svg>
		)
	}

	return icon && renderIcon[icon] ? renderIcon[icon] : null
}

export default IconsSVG
